import React from "react";
import {useHistory} from "react-router-dom"

const BottomNav = () => {

    const history = useHistory();

    const go =  (url) => {
        setTimeout(() => {
            history.push(url)
        }, 1500)
    }

    return(
        <div className="bottom-nav">
            <div className="nav-links">
                <li className="fa fa-home" onClick={() => go("/home")}></li>
                <li className="fa fa-info" onClick={() => go("/about")}></li>
                <li className="fa fa-cogs" onClick={() => go("/services")}></li>
                <li className="fa fa-phone" onClick={() => go("/contact")}></li>
            </div>
        </div>
    )
}

export default BottomNav;